"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var network_1 = require("./network");
// Получение ссылок на необходимые элементы DOM
var label = document.querySelector('.header__search-label');
var input = document.getElementById('search');
var giftsContainer = document.getElementById('gifts');
// Функция для обработки поискового запроса
var handleClickSearch = function () { return __awaiter(void 0, void 0, void 0, function () {
    var inputValue, searchData, randomData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                inputValue = input.value.trim();
                if (!(inputValue.length > 1)) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, network_1.search)(inputValue)];
            case 1:
                searchData = _a.sent();
                return [2 /*return*/, searchData.data.data];
            case 2: return [4 /*yield*/, (0, network_1.search)("Frontend")];
            case 3:
                randomData = _a.sent();
                return [2 /*return*/, randomData.data.data];
        }
    });
}); };
// Функция для отображения данных в подарках
var renderGifts = function (data) {
    input.value = '';
    // Очистка контейнера для подарков перед отображением новых данных
    giftsContainer.innerHTML = '';
    // Перебор полученных данных и создание соответствующих элементов DOM для каждого гифа
    data.forEach(function (gif) {
        console.log(gif.images.original.url);
        var giftElement = document.createElement('div');
        giftElement.classList.add('gift');
        var imageElement = document.createElement('img');
        imageElement.src = gif.images.original.url;
        imageElement.alt = gif.title;
        giftElement.appendChild(imageElement);
        giftsContainer.appendChild(giftElement);
    });
};
// Обработчик клика на кнопке поиска
var handleSearchClick = function () { return __awaiter(void 0, void 0, void 0, function () {
    var searchData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, handleClickSearch()];
            case 1:
                searchData = _a.sent();
                renderGifts(searchData);
                return [2 /*return*/];
        }
    });
}); };
// Добавление слушателя события клика на кнопку поиска
if (label) {
    label.addEventListener('click', handleSearchClick);
}
// Добавление слушателя события нажатия клавиши Enter при фокусе на поле ввода
input.addEventListener('keypress', function (event) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!(event.key === 'Enter')) return [3 /*break*/, 2];
                return [4 /*yield*/, handleSearchClick()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [2 /*return*/];
        }
    });
}); });
// Загрузка данных при загрузке страницы
document.addEventListener('DOMContentLoaded', function () { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, handleSearchClick()];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); });
